<input type="checkbox" id="{{metadata.name}}" class="form-check-input"
  [name]="metadata.name"
  [(ngModel)]="value"
  [disabled]="isReadOnly || metadata.readOnly"
  (ngModelChange)="onChange()">
<label class="form-check-label" for="{{metadata.name}}">
  <label-info [metadata]="metadata"></label-info>
  {{metadata.label}}
</label>
